export const benefits = [
  {
    img: "ManagedService/focus.svg",
    name: "بکاپ و بازیابی در شرایط  مدیریت متمرکز با OpenStack",
    desc: "زیرساخت سرورهای سازمان را از طریق پلتفرم ابری متن‌باز و سفارشی‌سازی شده، به‌صورت یکپارچه، ساده و مقیاس‌پذیر مدیریت کنید.",
    alt: "بکاپ و بازیابی در شرایط  مدیریت متمرکز با OpenStack",
    title: "بکاپ و بازیابی در شرایط  مدیریت متمرکز با OpenStack",
  },
  {
    img: "isolatedCloud/easyBuy.svg",
    name: "کاهش هزینه‌های سخت‌افزاری",
    desc: "با حذف نیاز به خرید سرورهای جدید و ارتقاء تجهیزات، هزینه‌های سرمایه‌ای زیرساخت را به شکل مؤثری کاهش دهید.",
    alt: "کاهش هزینه‌های سخت‌افزاری",
    title: "کاهش هزینه‌های سخت‌افزاری",
  },
  {
    img: "isolatedCloud/liveMigration.svg",
    name: "مهاجرت امن و سفارشی",
    desc: "با تحلیل دقیق زیرساخت فعلی توسط متخصصان آبالون، فرآیند مهاجرت به معماری ابری را به‌صورت امن و بدون اختلال اجرا کنید.",
    alt: "مهاجرت امن و سفارشی",
    title: "مهاجرت امن و سفارشی",
  },
  {
    img: "isolatedCloud/reliability.svg",
    name: "استفاده از زیرساخت فعلی",
    desc: "از سرورهای فعلی سازمان استفاده کرده و با کمک متخصصان آبالون آن‌ها را به معماری ابری ارتقاء دهید.",
    alt: "استفاده از زیرساخت فعلی",
    title: "استفاده از زیرساخت فعلی",
  },
  {
    img: "isolatedCloud/easyUse.svg",
    name: "پشتیبانی تخصصی ۲۴/۷",
    desc: "در تمام روزهای هفته و ساعات شبانه‌روز، از پشتیبانی فنی و راهکارهای فوری تیم متخصص آبالون بهره‌مند شوید.",
    alt: "پشتیبانی تخصصی ۲۴/۷",
    title: "پشتیبانی تخصصی ۲۴/۷",
  },
  {
    img: "isolatedCloud/advancedSecurity.svg",
    name: "حفظ امنیت داده",
    desc: "داده‌های حساس سازمان را داخل مجموعه نگهداری کرده و کنترل کامل بر امنیت و دسترسی آن‌ها را حفظ کنید.",
    alt: "حفظ امنیت داده",
    title: "حفظ امنیت داده",
  },
];

export const uses = [
  {
    img: "VPS/increase.svg",
    name: "منابع اختصاصی",
    desc: "زیرساخت فقط در اختیار سازمان شماست و منابع با دیگران به اشتراک گذاشته نمی‌شود.",
    alt: "منابع اختصاصی",
    title: "منابع اختصاصی",
  },
  {
    img: "VPS/resource.svg",
    name: "IP و شبکه اختصاصی",
    desc: "ارتباط بین سرویس‌ها در یک شبکه داخلی و ایزوله انجام می‌شود تا امنیت و کنترل بیشتری داشته باشید.",
    alt: "IP و شبکه اختصاصی",
    title: "IP و شبکه اختصاصی",
  },
  {
    img: "VPS/architect.svg",
    name: "اجرای راهکارهای انطباق با سیاست‌های سازمانی",
    desc: "می‌توانید زیرساخت را طبق الزامات امنیتی و ساختار داخلی سازمان خود تنظیم و مدیریت کنید.",
    alt: "انطباق با سیاست‌های سازمانی",
    title: "انطباق با سیاست‌های سازمانی",
  },
  {
    img: "VPS/panel.svg",
    name: "دسترسی کامل مدیریتی",
    desc: "با استفاده از داشبورد تحت وب، همه اجزای زیرساخت را به‌صورت لحظه‌ای مشاهده و مدیریت کنید.",
    alt: "دسترسی کامل مدیریتی",
    title: "دسترسی کامل مدیریتی",
  },
  {
    img: "VPS/image1.svg",
    name: "امکان ادغام با سرویس‌های دیگر",
    desc: "ابر خصوصی می‌تواند با دیگر خدمات ابری آبالون مثل CDN، بکاپ یا فضای ذخیره‌سازی ابری ترکیب شود.",
    alt: "امکان ادغام با سرویس‌های دیگر",
    title: "امکان ادغام با سرویس‌های دیگر",
  },
];

export const popularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN)",
    imgTitle: "شبکه توزیع محتوا (CDN)",
  },

  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "ManagedService-Service.svg",
    route: "/dedicated-server",
    imgAlt: "سرور اختصاصی",
    imgTitle: "سرور اختصاصی",
  },
  {
    title: "خدمات دواپس آبالون",
    desc: "بدون نیاز به استخدام نیروی داخلی، متخصصان ابری آبالون به تیم فنی سازمان شما می‌پیوندند تا تا مسیر رشد را با شتاب و بدون دغدغه طی کنید.",
    logo: "DNS.svg",
    route: "/devops",
    imgAlt: "خدمات دواپس آبالون",
    imgTitle: "خدمات دواپس آبالون",
  },
];

export const questions = [
  {
    title: "ابر خصوصی آبالون چه تفاوتی با سرویس‌های عمومی ابری دارد؟",
    answer:
      "ابر خصوصی آبالون فقط برای سازمان شما پیاده‌سازی می‌شود و منابع، داده‌ها و کنترل زیرساخت، کاملاً در اختیار خودتان است.",
  },
  {
    title:
      "آیا امکان استفاده از سرورهای فعلی سازمان برای راه‌اندازی ابر خصوصی وجود دارد؟",
    answer:
      "بله، در صورتی که سخت‌افزار فعلی شما از الزامات فنی پلتفرم پشتیبانی کند، نیازی به خرید سرور جدید نخواهید داشت.",
  },
  {
    title: "فرآیند مهاجرت از زیرساخت سنتی به ابر چقدر زمان می‌برد؟",
    answer:
      "بسته به پیچیدگی زیرساخت، نوع سرویس‌ها و نیازهای سفارشی، مدت زمان پروژه می‌تواند از چند روز تا چند هفته متغیر باشد.",
  },
  {
    title: "امنیت داده‌ها در ابر خصوصی چگونه تضمین می‌شود؟",
    answer:
      "تمام داده‌ها در داخل سازمان ذخیره می‌شوند و با لایه‌های امنیتی سفارشی‌شده، کنترل کامل بر دسترسی‌ها فراهم می‌شود.",
  },
  {
    title:
      "آیا می‌توان از نرم‌افزارهای فعلی مانند ERP یا CRM روی ابر خصوصی استفاده کرد؟",
    answer:
      "بله، خدمات ابر خصوصی آبالون امکان انتقال و اجرای نرم‌افزارهای حیاتی سازمانی مانند ERP، CRM و حسابداری را فراهم می‌کند.",
  },
  {
    title: "آیا ابر خصوصی قابلیت مقیاس‌پذیری دارد؟",
    answer:
      "بله، زیرساخت مبتنی بر OpenStack به شما این امکان را می‌دهد تا منابع پردازشی، ذخیره‌سازی و شبکه را به‌راحتی گسترش دهید.",
  },
  {
    title: "چه میزان دسترسی به پلتفرم ابری برای تیم IT سازمان فراهم می‌شود؟",
    answer:
      "تیم IT سازمان می‌تواند به‌صورت کامل و با دسترسی سطح بالا، مدیریت منابع، ماشین‌های مجازی و سرویس‌ها را بر عهده بگیرد.",
  },
  {
    title: "آیا امکان مانیتورینگ و مشاهده عملکرد سیستم در لحظه وجود دارد؟",
    answer:
      "بله، داشبوردهای مدیریتی پیشرفته برای نظارت بر منابع، مصرف، رخدادها و سلامت کلی زیرساخت در اختیار شما قرار می‌گیرد.",
  },
  {
    title: "پشتیبانی آبالون در چه سطوحی ارائه می‌شود؟",
    answer:
      "پشتیبانی فنی به‌صورت ۲۴/۷ از طریق تیکت و تماس تلفنی برای حل مشکلات و مشاوره‌های تخصصی ارائه می‌شود.",
  },
  {
    title: "هزینه راه‌اندازی ابر خصوصی چگونه محاسبه می‌شود؟",
    answer:
      "هزینه‌ها بر اساس تحلیل نیازهای سازمان، تعداد سرورها، سطح منابع و میزان پشتیبانی فنی مورد نیاز برآورد می‌شوند.",
  },
];
